import React, { createContext, useContext, useState } from 'react';

export interface UserProfile {
  name: string;
  initials: string;
  email: string;
  role: string;
  organization: string;
}

interface UserContextType {
  user: UserProfile;
  updateUser: (updates: Partial<UserProfile>) => void;
}

const defaultUser: UserProfile = {
  name: "Prime User",
  initials: "PU",
  email: "prime@jspark.in",
  role: "Administrator",
  organization: "JSPARK"
};

const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<UserProfile>(defaultUser);

  const updateUser = (updates: Partial<UserProfile>) => {
    setUser(prev => {
      if (updates.name) {
        const nameParts = updates.name.split(' ');
        const initials = nameParts.length > 1 
          ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`
          : nameParts[0].substring(0, 2);
        updates.initials = initials.toUpperCase();
      }
      return { ...prev, ...updates };
    });
  };

  return (
    <UserContext.Provider value={{ user, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};
